<template>
    <div
        :class="[
            {
                'cz2__funko-logo--is-name hide--below-md': isNameStep,
                'cz2__funko-logo--is-review': isReviewStep,
                'cz2__funko-logo--is-checkout': isCheckoutStep,
            },
        ]"
        class="cz2__funko-logo-wrapper"
    >
        <span class="cz2__funko-logo-link">
            <img
                src="../assets/images/funko-logo@2x.png"
                :alt="$t('LOGO_FUNKO')"
                class="cz2__funko-logo"
            >
        </span>

        <!-- <span
            v-if="isMariners"
            class="sm-x-icon"
        /> -->

        <img
            v-if="isMariners"
            src="../assets/images/branded/knicks/logo.png"
            alt="NY Knicks logo"
            class="sm-seattle-logo"
        >
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__steps {
            .cz2__funko-logo-wrapper {
                margin-top: 8px;

                display: flex;
                justify-content: center;

                position: relative;
                z-index: 1;
                background: transparent;
            }

            .cz2__funko-logo-link {
                border: 1px solid transparent;

                &:focus {
                    outline: none;
                    border-color: #ffffff;
                }
            }

            .cz2__funko-logo,
            .cz2__funko-logo-link {
                width: auto;
                height: 20px;
            }

            @include respond-above(lg) {
                .cz2__funko-logo-wrapper {
                    margin-right: 50%;
                }

                .cz2__funko-logo,
                .cz2__funko-logo-link {
                    width: 109px;
                    height: 37px;
                }
            }

            @include respond-above(xl) {
                .cz2__funko-logo,
                .cz2__funko-logo-link {
                    width: 209px;
                    height: 71px;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__steps {
            .cz2__funko-logo--is-checkout {
                background-color: transparent;
                position: absolute;
            }

            .cz2__funko-logo-wrapper {
                position: absolute;

                margin-top: 33.35px;

                width: 100%;
                left: 0;
            }

            .cz2__funko-logo {
                width: 218.71px;
                height: 76px;
            }
        }
    }

    #cz2.cz2.cz2__is-mariners {
        .cz2__funko-logo-wrapper {
            align-items: center;
            gap: 32px;

            &.cz2__funko-logo--is-review {
                margin-right: 0;
            }

            &.cz2__funko-logo--is-name {
                margin: 0;
                position: absolute;
            }
        }

        .sm-seattle-logo {
            height: 32px;
        }

        .sm-x-icon {
            border: 1px solid white;
            height: 18px;
        }

        @include respond-above(lg) {
            .cz2__funko-logo-wrapper {
                gap: 79px;
            }
            .sm-seattle-logo {
                height: 72px;
            }
            .sm-x-icon {
                height: 37px;
            }

            .cz2__funko-logo,
            .cz2__funko-logo-link {
                height: 56px !important;
                width: auto !important;
            }
        }

        @include respond-above(xl) {
            .cz2__funko-logo-wrapper {
                gap: 28px;
            }
        }
    }
</style>

<script>
    export default {
        computed: {
            funkoUrl() {
                return this.globalSettings?.['fun-site-url'] ?? 'https://www.funko.com/';
            },

            globalSettings() {
                return this.$store.state.customizer?.globalSettings?.blueprint?.custom;
            },

            isMariners() {
                return this.$store.state.isMariners;
            },

            currentGroupCode() {
                return this.$store.state.customizer.currentGroup?.code;
            },

            isNameStep() {
                return this.currentGroupCode === 'Name';
            },

            isReviewStep() {
                return this.currentGroupCode === 'Review';
            },

            isCheckoutStep() {
                return this.currentGroupCode === 'Checkout';
            },
        },

        methods: {
            tapLogo($event) {
                if (this.isKiosk) {
                    $event.preventDefault();

                    this.$store.dispatch('tapLogo');
                }
            },
        },
    };
</script>
